import styled from 'styled-components';

export const FeesBySolutionWizardStyled = styled.div`
  .modalUI__title {
    font-family: ${props => props.theme.fontSemiBold};
    font-size: 18px;
    color: ${props => props.theme.uiColors.feesBySolutionWizardTitle};
  }
  
  .stepsWizardHeader__title {
    font-family: ${props => props.theme.fontSemiBold};
    font-size: 14px;
    color: ${props => props.theme.uiColors.feesBySolutionWizardStep};
  }
`;
